export default __webpack_public_path__ + "static/media/open-deck.3c6d1438.svg";